import {CBaseRecord, IBaseRecord} from './_base'
import {CAward} from './award'
import {CBusiness} from './business'
import {CConcept} from './concept'
import {CPackage} from './package'
import {CProject} from './project'
import {CTenant, CUser} from './user'

class CRoot extends CBaseRecord<IBaseRecord> {
  static isRoot = true
  static record_name = ''
  static external_id = ''
  static children = {
    projects: CProject,
    users: CUser,
    tenants: CTenant,
    packages: CPackage,
    'entities.award': CAward,
    'entities.business': CBusiness,
    'entities.concept': CConcept,
  }
}

// By telling CRoot to register with its descendants, we trigger a cascade
// down the entire chain. This results in every record class being registered.

// (This is a trick to allow each record type to know about both its parents
// and its children, without causing circular dependencies. It also means we
// only have to define the relationship from parent to child; the reverse
// relationship is computed automatically.)
CRoot.registerWithDescendants()

export {CRoot}
